import React from "react";

import { GenericBannerText } from "@components/BannerSection";
import Button from "./Button";
import { MarkdownPageContext } from "@utils/MarkdownUtils";

export type BannerProps = {
  /** On Click callback for form submit */
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  genericText: GenericBannerText;
  /** On Click callback for form submit */
  visibleSubtitle?: boolean;
  submitButtonId?: string;
};

export const Banner = ({
  onClick,
  visibleSubtitle = true,
  submitButtonId,
  genericText,
}: BannerProps) => (
  <div className="mx-auto max-w-md sm:max-w-3xl lg:max-w-7xl">
    <div className="banner-background relative overflow-hidden rounded-3xl bg-accuRankerPurple-500 px-6 py-5 shadow-xl sm:px-12 sm:py-8">
      <div className="relative">
        <div className="sm:text-center">
          <h2 className="text-3xl font-medium tracking-tight text-white sm:text-4xl [&>span>span]:text-accuRankerOrange-500">
            <MarkdownPageContext>
              {genericText?.startTrialBannerTitle}
            </MarkdownPageContext>
          </h2>
          <div className="mt-5 justify-center sm:mx-auto sm:flex sm:max-w-[12rem]">
            <Button
              id={submitButtonId}
              onClick={onClick}
              color="green"
              className="m-auto h-12 w-full disabled:opacity-95"
            >
              {genericText?.startTrialBannerButtonText}
            </Button>
          </div>
          {visibleSubtitle && (
            <p className="mx-auto mt-5 mb-0 max-w-2xl text-center text-lg text-gray-200">
              {genericText?.startTrialBannerSubtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default Banner;
